
export const Selectors = {
  form: 'form.variations_form',
  attributeInputs: '.variations_form .variations select',
}
